export const environment = {
  API_URL: '/mocks',
  mock: false,
  cardnet: {
    key: 'Ssl69aiGxuf-ZnZfE-6ckE_I56ONV7HQ',
    env: 'https://servicios.cardnet.com.do/servicios/tokens/v1',
  },
  firebase: {
    apiKey: 'AIzaSyApWImTgjrngDLTNNrZJcLOyaI1cAi62A0',
    authDomain: 'mi-cable-go-dev.firebaseapp.com',
    projectId: 'mi-cable-go-dev',
    storageBucket: 'mi-cable-go-dev.firebasestorage.app',
    messagingSenderId: '856659629323',
    appId: '1:856659629323:web:ec957fb616b282216d3e0e',
  },
};
